module.exports = __WEBPACK_EXTERNAL_MODULE_49__;


//////////////////
// WEBPACK FOOTER
// external "comsMobx"
// module id = 49
// module chunks = 0